import * as angular from 'angular';
import { StudentSupportModalCtrl } from './student-support-modal.controller';
import { StudentSupportModal } from './student-support-modal.service';

export const StudentSupportModalModule = angular
  .module('studentSupportModalModule', [])
  .service('StudentSupportModal', StudentSupportModal)
  .controller('StudentSupportModalCtrl', StudentSupportModalCtrl).name;
